import { Tier, TierUser, TierUserProtection, TierUsersResult, TierUsersTabCounts, TierView } from '../domain/types';
import {
  ListProjectTierUsersResponseDTO,
  ProjectTierResponseDTO,
  TierUserDTO,
  TierUserProtectionDTO,
  TierViewDTO,
} from './dtos';

export function mapTierDTOToTier(dto: ProjectTierResponseDTO): Tier {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    slug: dto.slug,
    rank: dto.rank,
    audienceId: dto.audience_id,
    requiresManualProjectApproval: dto.requires_manual_project_approval ?? false,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
  };
}

function mapTierViewDTO(dto: TierViewDTO | null): TierView | null {
  if (!dto) return null;
  return { id: dto.id, name: dto.name, slug: dto.slug, rank: dto.rank };
}

function mapTierUserProtectionDTO(dto: TierUserProtectionDTO): TierUserProtection {
  return {
    tierId: dto.tier_id,
    tierName: dto.tier_name,
    tierRank: dto.tier_rank,
    endsAt: dto.ends_at,
    createdAt: dto.created_at,
    isBelowEffective: dto.is_below_effective,
  };
}

export function mapTierUserDTOToTierUser(dto: TierUserDTO): TierUser {
  return {
    projectAffiliateId: dto.project_affiliate_id,
    userIdentifier: dto.user_identifier,
    userIdentifierType: dto.user_identifier_type,
    displayName: dto.display_name,
    organicTier: mapTierViewDTO(dto.organic_tier),
    effectiveTier: mapTierViewDTO(dto.effective_tier),
    currentTier: mapTierViewDTO(dto.current_tier),
    tierApprovalStatus: dto.tier_approval_status,
    protections: (dto.protections ?? []).map(mapTierUserProtectionDTO),
    source: dto.source,
    joinedAt: dto.joined_at,
    protectionEndsAt: dto.protection_ends_at,
    approvalState: dto.approval_state,
    isMember: dto.is_member,
    lapsed: dto.lapsed,
  };
}

export function mapTierUsersResponseToResult(dto: ListProjectTierUsersResponseDTO): TierUsersResult {
  const tabCounts: TierUsersTabCounts = {
    all: dto.tab_counts?.all ?? 0,
    members: dto.tab_counts?.members ?? 0,
    candidates: dto.tab_counts?.candidates ?? 0,
    lapsed: dto.tab_counts?.lapsed ?? 0,
  };
  return {
    totalCount: dto.total_count,
    tabCounts,
    results: (dto.results ?? []).map(mapTierUserDTOToTierUser),
  };
}
